import React from "react";
import MaintenanceSchedulesCalendar from "./MaintenanceSchedulesCalendar";

function MaintenanceSchedulesCalendarView({
    devices,
    selectedRows,
    onSelectedRowsChange,
    onRefresh,
    onEventClick,
    onEditSchedule,
    filterText,
}) {
    return (
        <MaintenanceSchedulesCalendar
            devices={devices}
            onRefresh={onRefresh}
            onEventClick={onEventClick}
            onEditSchedule={onEditSchedule}
            filterText={filterText}
        />
    );
}

export default MaintenanceSchedulesCalendarView;
